export default "__VITE_ASSET__CQc0k6I8__"